import { useNavigate } from "react-router-dom";

import { PageContainer } from "@/features/ui";

import { RoleForm } from "@/features/roles/role-form/role-form";
import { apiClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

import { Button } from "@mui/material";

export const CreateRole = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async ({ name, permissions }) => {
    try {
      await apiClient.post("roles", {
        name,
        permissions,
      });
      navigate(-1);
    } catch (error) {
      showSnackbar(
        getErrorMessage(error, "Gagal membuat peran")
      );
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Tambah Peran"
      breadcrumbs={[
        { title: "Peran", path: "/setting/roles" },
        { title: "Tambah" },
      ]}
    >
      <RoleForm
        onSubmit={handleSubmit}
        renderActionButton={({ isSubmitting }) => (
          <Button
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Tambah
          </Button>
        )}
      />
    </PageContainer>
  );
};
